export interface ScaleFactorState {
    scaleFactor: number;
    scaleFactorToFitViewport: number;
}

export function computeRelativeScaleFactor(scaleFactor: number, scaleFactorToFitViewport: number) {
    return Math.trunc(Math.round((scaleFactor / scaleFactorToFitViewport) * 100));
}
